import './Footer.css'
export default function Footer(){
    return (
      <footer className="footer--pin">
        <div className='bg-linkss'>
          <div className='linkss'>
            <img src="https://www.iconpacks.net/icons/2/free-twitter-logo-icon-2429-thumb.png" height="70" width="70" />
            <a href="www.facebook.com">Twitter</a>
          </div>
          <div className='linkss'>
            <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/1/1b/Facebook_icon.svg/2048px-Facebook_icon.svg.png" height="70" width="70" />
            <a href="www.facebook.com">Facebook</a>
          </div>
          <div className='linkss'>
            <img src="https://cdn-icons-png.flaticon.com/512/5968/5968866.png" width="70" height="70" />
            <a href="www.facebook.com">Github</a>
          </div>
          </div>
          <p>&#169; COPYRIGHT</p>
      </footer>
    )
  }